export default __webpack_public_path__ + "static/media/portfolio-104.f2d33052.jpg";